var exports = {
  "layer": "layer-TGh6R",
  "wordLayer": "wordLayer-TGh6R",
  "geometryLayer": "geometryLayer-TGh6R",
  "searchLayer": "searchLayer-TGh6R",
  "thumbs": "thumbs-TGh6R",
  "word": "word-TGh6R",
  "poly": "poly-TGh6R",
  "hidden": "hidden-TGh6R",
  "searchterm": "searchterm-TGh6R",
  "focused": "focused-TGh6R",
  "geo_words": "geo_words-TGh6R",
  "geo_lines": "geo_lines-TGh6R",
  "geo_paragraphs": "geo_paragraphs-TGh6R",
  "geo_blocks": "geo_blocks-TGh6R",
  "geo_entity_place": "geo_entity_place-TGh6R",
  "geo_entity_subject": "geo_entity_subject-TGh6R",
  "geo_entity_name": "geo_entity_name-TGh6R",
  "geo_entity_glossary": "geo_entity_glossary-TGh6R",
  "geo_interactor": "geo_interactor-TGh6R",
  "geo_pagebox": "geo_pagebox-TGh6R",
  "modified": "modified-TGh6R",
  "highlight": "highlight-TGh6R",
  "selected": "selected-TGh6R",
  "selectable": "selectable-TGh6R",
  "deleted": "deleted-TGh6R",
  "cropInner": "cropInner-TGh6R",
  "cropOuter": "cropOuter-TGh6R",
  "hl_label": "hl_label-TGh6R",
};

__webpack_require__.r(module.exports = exports);
